
	import { defineComponent } from 'vue';

	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';
	import IncorrectPermissions from '@/ChildrenComponents/IncorrectPermissions.vue';
	import FiscalYearReportSearch from '@/ChildrenComponents/Reports/FiscalYearReportSearch.vue';
    import ReportExporter from '@/ChildrenComponents/ReportExporter.vue';

	import { ComponentType } from '@/Enums/ComponentType';

	import { IInternalUser } from '@/Models/IInternalUser';
	import { IPostProgramRecidivismReport, IFiscalYearReportSearch, IArrestSummary } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

    import { ReportService } from '@/Services/Report/report-service';
    import { DateHelper } from '@/Services/Helper/date-helper';
    import { doesUserRoleHaveComponentViewPermissions } from '@/Services/Helper/component-permissions-helper';
	import { useUserStore } from '@/Services/Store/user-store';

	export default defineComponent({
		name: 'post-program-recidivism-report',
		components: { LoadingSpinner, IncorrectPermissions, FiscalYearReportSearch, ReportExporter },
		setup(): { currentUser: IInternalUser | null } {
			const userStoreInstance = useUserStore();
			return { currentUser: userStoreInstance.$state.cstInternalUser };
		},
		data () {
			return {
				reportData: [] as IPostProgramRecidivismReport[],
				summaryData: [] as IArrestSummary[],
				isLoading: false,
				isSearching: false,
				headers: [
                    { title: "Participant ID", key: "participantId", sortable: true, align: "start" },
                    { title: "Last Name", key: "lastName", sortable: true, align: "start" },
                    { title: "Program", key: "programName", sortable: true, align: "start" },
                    { title: "Incident Date", key: "arrestDate", sortable: true, align: "start" },
                    { title: "Charge Type", key: "chargeType", sortable: true, align: "start" },
                    { title: "Date Entered", key: "dateEntered", sortable: true, align: "start" },
				] as IDataTableHeader[],
				summaryHeaders: [
                    { title: "Program", key: "programName", sortable: true, align: "start" },
                    { title: "Participant Count", key: "totalParticipants", sortable: true, align: "start" },
                    { title: "Recidivism Count", key: "totalArrests", sortable: true, align: "start" },
                    { title: "Percentage", key: "arrestPercentage", sortable: true, align: "start" },
				] as IDataTableHeader[],
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				Promise.all([
					ReportService.getPostProgramRecidivismReportData(searchDto),
					ReportService.getPostProgramRecidivismSummaryReportData(searchDto),
				]).then(([data, summary]) => {
					this.reportData = data;
					this.summaryData = summary;

					this.reportData.forEach(x => {
						x.arrestDate = DateHelper.formatDateUtc(x.arrestDate);
						x.dateEntered = DateHelper.formatDateUtc(x.dateEntered);
					});
					this.summaryData.forEach(x => {
						x.arrestPercentage = typeof x.arrestPercentage == "string" ? x.arrestPercentage : (x.arrestPercentage * 100).toFixed(2) + "%";
					});
				}).finally(() => this.isSearching = false);
			},
		},
		computed: {
			canView(): boolean {
				return doesUserRoleHaveComponentViewPermissions(this.currentUser?.attachedRoles ?? [], ComponentType.Report);
			},
		},
	});
